import { useNavigate } from "react-router-dom";
import { Flag, FileText, Plus, ExternalLink } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { fmtMoney } from "../lib/api";

// Admin Home: the journey wrapped up (Completed) → celebrate + point to what's next.
// Or: the dates have passed but it's still Current → nudge to End it.
export default function TripWrapUp({ stats }) {
  const { config } = useAuth();
  const navigate = useNavigate();
  if (!config?.id) return null;
  const today = new Date().toISOString().slice(0, 10);
  const endPassed = config.end_date && config.end_date < today;

  if (config.status === "completed") {
    const bits = [
      stats?.dispatches != null && `${stats.dispatches} dispatches`,
      stats?.prayers != null && `${stats.prayers} prayers`,
      stats?.partners != null && `${stats.partners} partners`,
      stats?.raised != null && `${fmtMoney(stats.raised, config.currency)} raised`,
    ].filter(Boolean).join(" · ");
    return (
      <div className="rounded-3xl p-5 text-white shadow-[0_14px_40px_rgba(13,35,64,0.28)]" style={{ background: "linear-gradient(135deg,#0d2340,#173a66)" }} data-testid="trip-wrapup-card">
        <div className="text-[11px] uppercase tracking-[0.2em] opacity-70">Journey complete{config.ended_at ? ` · ${new Date(config.ended_at).toLocaleDateString("en-US", { month: "short", day: "numeric" })}` : ""}</div>
        <div className="font-heading font-extrabold text-2xl mt-1 leading-tight">{config.trip_name} is complete 🎉</div>
        {bits && <p className="text-sm opacity-85 mt-2">{bits}. Share the story, then start your next journey.</p>}
        <div className="flex gap-2 mt-4">
          <button data-testid="wrapup-plan-next" onClick={() => navigate("/app/trips/new")} className="flex-1 rounded-full h-11 bg-[#E0A73A] text-[#0A1B33] font-semibold text-sm flex items-center justify-center gap-1.5"><Plus className="h-4 w-4" /> Plan next journey</button>
          <button data-testid="wrapup-report" onClick={() => navigate(`/app/trips/${config.id}/report`)} className="flex-1 rounded-full h-11 border border-white/40 text-white font-semibold text-sm flex items-center justify-center gap-1.5"><FileText className="h-4 w-4" /> Trip report</button>
        </div>
        {config.report?.external_url && <a data-testid="wrapup-external" href={config.report.external_url} target="_blank" rel="noreferrer" className="mt-2 flex items-center justify-center gap-1 text-xs text-white/80 underline-offset-2 hover:underline"><ExternalLink className="h-3 w-3" /> Full report: {config.report.external_url}</a>}
      </div>
    );
  }

  if (config.status === "current" && endPassed) {
    return (
      <button data-testid="trip-end-nudge" onClick={() => navigate(`/app/trips/${config.id}`)} className="w-full text-left rounded-2xl p-4 bg-white border border-[#C9973A]/40 shadow-[0_4px_24px_rgba(44,44,62,0.04)] flex items-center gap-3">
        <span className="h-10 w-10 rounded-xl accent-bg text-white flex items-center justify-center shrink-0"><Flag className="h-5 w-5" /></span>
        <span className="flex-1 min-w-0">
          <span className="block font-semibold text-[#0d2340] text-sm">Home safe? End {config.trip_name}</span>
          <span className="block text-xs text-muted-foreground">The dates have passed. Ending it unlocks the wrap-up and lets you plan what's next — you can still post.</span>
        </span>
      </button>
    );
  }
  return null;
}
